const GLOBAL_ERROR_PAGE_CODES = [529, 599] as const;
const INLINE_CONTAINER_ERROR_CODES = [403, 404, 500] as const;

type TGlobalErrorPageCode = (typeof GLOBAL_ERROR_PAGE_CODES)[number];
type TInlineContainerErrorCode = (typeof INLINE_CONTAINER_ERROR_CODES)[number];

type ErrorWithStatus = {
  status?: unknown;
  originalStatus?: unknown;
  data?: unknown;
};

function toNumericStatus(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function normalizeContainerErrorStatus(error: unknown): number | null {
  if (!error || typeof error !== 'object') {
    return null;
  }

  const typedError = error as ErrorWithStatus;
  const directStatus = toNumericStatus(typedError.status);
  if (directStatus != null) {
    return directStatus;
  }

  const originalStatus = toNumericStatus(typedError.originalStatus);
  if (originalStatus != null) {
    return originalStatus;
  }

  if (typedError.data && typeof typedError.data === 'object') {
    const dataStatus = toNumericStatus(
      (typedError.data as { statusCode?: unknown }).statusCode,
    );
    if (dataStatus != null) {
      return dataStatus;
    }
  }

  return null;
}

export function isGlobalErrorPageStatus(
  status: number | null | undefined,
): status is TGlobalErrorPageCode {
  return (
    typeof status === 'number' &&
    GLOBAL_ERROR_PAGE_CODES.includes(status as TGlobalErrorPageCode)
  );
}

export function isInlineContainerErrorStatus(
  status: number | null | undefined,
): status is TInlineContainerErrorCode {
  return (
    typeof status === 'number' &&
    INLINE_CONTAINER_ERROR_CODES.includes(status as TInlineContainerErrorCode)
  );
}
